import React, { Component } from "react";
import sanitizeHtml from "sanitize-html";

class ContentTile extends Component {
  constructor(props) {
    super(props);

    this.state = {
      svgStyle: {
        display: "inline-block",
      }
    };

    this.contentTileContent = React.createRef();
  }

  // Allow only a super restricted set of tags and attributes
  cleanHtml(dirty) {
    return sanitizeHtml(dirty, {
      allowedTags: [
        "b",
        "i",
        "em",
        "strong",
        "a",
        "p",
        "img",
        "h2",
        "h3",
        "li",
        "ul",
        "br",
        "div"
      ],
      allowedAttributes: {
        a: ["href", "class"],
        img: ["src", "class"],
        p: ["class"],
        div: ["class"]
      },
      transformTags: {
        img: function (tagName, attribs) {
          //custom magic goes here
          if (!attribs.src.startsWith("https://wvusstatic.com1")) {
            attribs.src = "";
          }
          return {
            tagName: "img",
            attribs: {
              src: "",
              class: "clean-image",
            },
          };
        },
      },
    });
  }



  render() {
    return (
      <div
        className={`content-tile`}
        ref={this.contentTileContent}
      >
        <div className={`content-tile__content`}>
          { this.props.image_element ? (
            <div className="content-tile__image"
              dangerouslySetInnerHTML={{
                __html: (this.props.image_element),
              }}
            />
          ) : (<> </>)}
          <div className={`content__inner`}>
            <p className="beta content__title">{this.props.title}</p>
            <div
              dangerouslySetInnerHTML={{
                __html: this.cleanHtml(this.props.content),
              }}
            />
          </div>
        </div>
      </div>
    );
  }
}

export default ContentTile;
